import ax from 'axios';
const apiService = ax.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
  },
});

apiService.interceptors.response.use(undefined, error=>{
  return Promise.reject(error?.response?.data || error);
})

export const getAPIService = (url:string, data = {headers:{},params:{}}) => {  
  return apiService.get(url, {
    headers: data.headers,
    params:data.params
  })
};

export const postAPIService = (url:string, body:any , data = {headers:{},params:{}}) => {
  return apiService.post(url, body,{
    headers: data.headers,
    params:data.params
  });
};

export default { getAPIService , postAPIService};
